export const SALES_ID = 1
export const ITEMS_ID = 2
export const CONVERSION_ID = 3
export const GM0_ID = 4
export const RETURNS_ID = 5
export const NLP_ID = 6
export const PRODUCTIVITY_ID = 7
export const UTG_ID = 8